import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { EASE } from "@/lib/scroll";

const CATS = [
  {
    src: "/images/cat-licking.webp",
    alt: "Pisică tabby făcând curat după masa NOSA",
    cap: "Lins până la ultima picătură",
  },
  {
    src: "/images/cat-jar.webp",
    alt: "Pisică tabby lângă farfuria și borcanul NOSA",
    cap: "Abia așteaptă următoarea masă",
  },
  {
    src: "/images/cat-cream.webp",
    alt: "Pisică crem așezată lângă farfuria cu hrană NOSA",
    cap: "O masă meritată",
  },
  {
    src: "/images/cat-eating-1.webp",
    alt: "Pisică tabby mâncând din farfurie, văzută din profil",
    cap: "Moment de deliciu",
  },
  {
    src: "/images/cat-standing.webp",
    alt: "Pisică crem stând lângă farfuria cu hrană NOSA",
    cap: "Partea preferată a zilei",
  },
];

const Card = ({ cat, n }) => (
  <figure
    className="group relative h-72 w-[320px] shrink-0 overflow-hidden rounded-3xl border border-gold/15 sm:w-[400px]"
    data-testid={`cat-band-photo-${n}`}
  >
    <img
      src={cat.src}
      alt={cat.alt}
      className="h-full w-full object-cover transition-transform duration-[2s] ease-out group-hover:scale-[1.05]"
    />
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
    <figcaption className="absolute bottom-0 left-0 flex w-full items-center justify-between p-5">
      <span className="flex items-center gap-2.5 font-mono text-[9px] uppercase tracking-[0.2em] text-cream/85">
        <Heart size={11} className="fill-gold text-gold" />
        {cat.cap}
      </span>
      <span className="h-1.5 w-1.5 rotate-45 bg-gold/80" />
    </figcaption>
  </figure>
);

export default function CatBand() {
  return (
    <section
      className="relative overflow-hidden border-t border-gold/10 py-24 lg:py-32"
      data-testid="cat-band"
    >
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mx-auto mb-14 max-w-7xl px-6 text-center lg:px-10"
      >
        <div className="mb-6 flex items-center justify-center gap-4">
          <span className="h-px w-12 bg-gold/70" />
          <p className="font-mono text-[10px] uppercase tracking-[0.38em] text-gold sm:text-[11px]">
            Mese NOSA
          </p>
          <span className="h-px w-12 bg-gold/70" />
        </div>
        <h2 className="mx-auto max-w-2xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
          Boluri goale, <em className="text-gold-gradient italic">mustăți fericite.</em>
        </h2>
      </motion.div>

      <div className="relative overflow-hidden" aria-hidden="true">
        <div className="flex w-max animate-marquee gap-6 pr-6">
          {[...CATS, ...CATS].map((cat, i) => (
            <Card key={`${cat.src}-${i}`} cat={cat} n={(i % CATS.length) + 1} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
      </div>
    </section>
  );
}
